import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { isNextRoute } from '../utils/nextRoutes';

// ----------------------------------------------------------------------

/**
 * Wraps an SPA page that now lives in the Next app. A react-router navigation
 * to it becomes a full page load, which nginx sends to Next. When Next is not
 * in front (dev, stage) the SPA page renders as before.
 */
export default function NextRoute({ children }) {
  const { pathname, search, hash } = useLocation();

  if (isNextRoute(pathname)) {
    window.location.replace(`${pathname}${search}${hash}`);
    return null;
  }

  return children ?? null;
}

NextRoute.propTypes = {
  children: PropTypes.node,
};
